import { render } from "./update_proposal.vue?vue&type=template&id=0c1426cb"
import script from "./update_proposal.vue?vue&type=script&lang=js"
export * from "./update_proposal.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/one_eu/web_head/releases/20260421203947/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__